import React, { FC, PropsWithChildren } from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useAppearanceStyles, useGlobalStyles } from './styles';
import { ISurfaceBaseProps } from './types';

export const SurfaceBase: FC<PropsWithChildren<ISurfaceBaseProps>> = (props: ISurfaceBaseProps) => {
  const {
    appearance,
    children,
    classNames = [],
    styles,
  } = props;
  const classes = useGlobalStyles();
  const appearanceClasses = useAppearanceStyles();

  // merge classes
  const surfaceClass = mergeClasses(
    ...classNames,
    classes.container,
    appearance && appearanceClasses[appearance],
  );

  return <div className={surfaceClass} style={styles && styles}>{children && children}</div>;
};

// Export Surface base component
SurfaceBase.displayName = 'SurfaceBase';
